import React from 'react';
import { View } from 'react-native';
import Svg, { Line } from 'react-native-svg';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const STROKE_WIDTH = 1; // note: value smaller than 1 makes the svg line on some devices
const CIRCLE_RADIUS = rem(3.5);
export const DashedLine = ({ top }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<View pointerEvents={'none'} style={[styles.svgParent, { top: top - STROKE_WIDTH / 2 }]}>
      <Svg viewBox={`0 0 100 ${STROKE_WIDTH}`} preserveAspectRatio={'none'} style={styles.svg}>
        <Line x1={0} y1={STROKE_WIDTH / 2} x2={'100%'} y2={STROKE_WIDTH / 2} stroke={colors.text.tertiary} strokeWidth={STROKE_WIDTH} strokeLinecap={'round'} strokeDasharray={'2,4'} vectorEffect={'non-scaling-stroke'}/>
      </Svg>
      <View style={styles.circle}/>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    svgParent: {
        position: 'absolute',
        left: 0,
        width: '100%',
        height: STROKE_WIDTH,
        paddingRight: CIRCLE_RADIUS * 2, // to not overlap with the circle
    },
    svg: {
        width: '100%',
        height: STROKE_WIDTH,
    },
    circle: {
        position: 'absolute',
        top: -CIRCLE_RADIUS,
        right: 0,
        height: CIRCLE_RADIUS * 2,
        width: CIRCLE_RADIUS * 2,
        borderRadius: CIRCLE_RADIUS,
        backgroundColor: colors.text.tertiary,
    },
}));
